import { render } from "./ProfileVIew.vue?vue&type=template&id=15c9d18a"
import script from "./ProfileVIew.vue?vue&type=script&lang=js"
export * from "./ProfileVIew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__